import { Input } from '@starsoft/common/components';
import { ConfirmationMethodCardPropsIndicatorProps } from './props';

/**
 * ConfirmationMethodCardPropsIndicator component that renders a radio input indicator
 * for confirmation method selection cards
 *
 * @component
 * @param {Object} props - Component props
 * @param {boolean} props.isLoading - Whether the indicator is in loading state
 * @param {boolean} props.selected - Whether this indicator is selected
 * @returns {JSX.Element} Radio input component with loading and selected states
 */
export default function ConfirmationMethodCardPropsIndicator({
  isLoading,
  selected,
}: ConfirmationMethodCardPropsIndicatorProps) {
  return <Input type="radio" checked={selected} isLoading={isLoading} />;
}
